import api from "@/services/axios";

export default {



  // Users
  getUserInfo() { return api.get("/users/me")},
  updateUserInfo(data)  { return api.put("/users/me", data)},
  updateUserPassword(data) {return api.put("/users/me/password", data)},
  getUserSettings() { return api.get("/users/me/settings")},
  updateUserSettings(data) { return api.put("/users/me/settings", data)},
  
  // Companies
  getCompanies() { return api.get("/companies");},                 // Get a list of all companies
  getCompaniesSummary() { return api.get("/companies/summary"); }, // Counts: total, customers, partners
  getCompanyById(id) { return api.get(`/companies/${id}`); },      // Get details for a single company by ID
  createCompany(data) { return api.post("/companies", data); },    // Create a new company
  updateCompany(id, data) { return api.put(`/companies/${id}`, data); },  // Update an existing company
  deleteCompany(id) { return api.delete(`/companies/${id}`); },    // Delete a company
  getIndustries()   { return api.get("/industries"); },             // Industry catalog for dropdowns


  // Tags
  getTags() { return api.get("/siem/tags"); },
  getTagsSummary() { return api.get("/siem/tags/summary"); },
  createTag(data) { return api.post("/siem/tags", data); },
  updateTag(id, data) { return api.put(`/siem/tags/${id}`, data); },
  deleteTag(id) { return api.delete(`/siem/tags/${id}`); },
  getTagsUsage(limit = null) {
    const params = limit ? { params: { limit } } : {}; // Falls limit gesetzt ist, als Query-Parameter übergeben
    return api.get("/siem/tags/usage", params);
  },

  // Workflows
  getWorkflows(params) { return api.get("/siem/workflows", { params }); },
  getWorkflowsOptimized(params) { return api.get("/siem/workflows/optimized", { params }); },
  getWorkflow(id, params) { return api.get(`/siem/workflows/${id}`, { params }); },
  createWorkflow(data) { return api.post("/siem/workflows", data); },
  updateWorkflow(id, data) { return api.put(`/siem/workflows/${id}`, data); },
  getWorkflowTranslations(id) { return api.get(`/siem/workflows/${id}/translations`); },
  updateWorkflowTranslation(id, lang, data) { return api.put(`/siem/workflows/${id}/translations/${lang}`, data); },
  deleteWorkflow(id) { return api.delete(`/siem/workflows/${id}`); },
  getWorkflowActivity() { return api.get("/siem/workflows/activity"); },


  getWorkflowsChanges() { return api.get("/siem/workflow-changes");},
  getWorkflowsSummary() { return api.get("/siem/workflow-summary");},
  // Workflow mappings (MITRE / ISACA)
  getWorkflowMitreMappings(id) { return api.get(`/siem/workflows/${id}/mitre-mappings`); },
  createWorkflowMitreMapping(id, data) { return api.post(`/siem/workflows/${id}/mitre-mappings`, data); },
  updateWorkflowMitreMapping(id, data) { return api.put(`/siem/workflows/${id}/mitre-mappings`, data); },
  deleteWorkflowMitreMapping(id, params) { return api.delete(`/siem/workflows/${id}/mitre-mappings`, { params }); },
  getWorkflowIsacaMappings(id) { return api.get(`/siem/workflows/${id}/isaca-mappings`); },
  createWorkflowIsacaMapping(id, data) { return api.post(`/siem/workflows/${id}/isaca-mappings`, data); },
  updateWorkflowIsacaMapping(id, data) { return api.put(`/siem/workflows/${id}/isaca-mappings`, data); },
  deleteWorkflowIsacaMapping(id, params) { return api.delete(`/siem/workflows/${id}/isaca-mappings`, { params }); },
  getMitreTactics(params) { return api.get("/siem/mitre/tactics", { params }); },
  getMitreTechniques(params) { return api.get("/siem/mitre/techniques", { params }); },
  // MITRE ATT&CK Coverage-Matrix (/threat-intel/mitre)
  getMitreMatrix(params) { return api.get("/siem/mitre/matrix", { params }); },
  getMitreTechniqueDetail(mitreId, params) { return api.get(`/siem/mitre/techniques/${encodeURIComponent(mitreId)}/detail`, { params }); },
  getMitreTechniqueEvents(mitreId, params) { return api.get(`/siem/mitre/techniques/${encodeURIComponent(mitreId)}/events`, { params }); },
  getIsacaUseCases(params) { return api.get("/siem/isaca/use-cases", { params }); },
  // Streams
  getStreams(params) { return api.get("/siem/streams", { params }); },
  getStreamsSummary() { return api.get("/siem/streams/summary"); },
  getStreamsStats() { return api.get("/siem/streams/stats"); },
  getWorkflowsStats() { return api.get("/siem/workflows/stats"); },
  getStreamCategories() { return api.get("/siem/streams/categories"); },
  createStream(data) { return api.post("/siem/streams", data); },
  updateStream(id, data) { return api.put(`/siem/streams/${id}`, data); },
  deleteStream(id) { return api.delete(`/siem/streams/${id}`); },
  cloneStream(id)  { return api.post(`/siem/streams/${id}/clone`); },
  previewStreamCombination(combination) { return api.post("/siem/streams/combination/preview", { combination }); },
  getWorkflowStreams(id) { return api.get(`/siem/workflows/${id}/streams`); },
  addStreamToWorkflow(id, data) { return api.post(`/siem/workflows/${id}/streams`, data); },
  removeStreamFromWorkflow(id, streamId) { return api.delete(`/siem/workflows/${id}/streams/${streamId}`); },
  updateWorkflowStream(id, streamId, data) { return api.put(`/siem/workflows/${id}/streams/${streamId}`, data); },
  reorderWorkflowStreams(id, data) { return api.put(`/siem/workflows/${id}/streams/reorder`, data); },
  getStreamConditions(id, streamId) { return api.get(`/siem/workflows/${id}/streams/${streamId}/conditions`); },
  addStreamCondition(id, streamId, data) { return api.post(`/siem/workflows/${id}/streams/${streamId}/conditions`, data); },
  updateStreamCondition(id, streamId, conditionId, data) { return api.put(`/siem/workflows/${id}/streams/${streamId}/conditions/${conditionId}`, data); },
  deleteStreamCondition(id, streamId, conditionId) { return api.delete(`/siem/workflows/${id}/streams/${streamId}/conditions/${conditionId}`); },

  // Complex Conditions
  getComplexConditions() { return api.get("/siem/complex-conditions"); },
  createComplexCondition(data) { return api.post("/siem/complex-conditions", data); },
  updateComplexCondition(id, data) { return api.put(`/siem/complex-conditions/${id}`, data); },
  deleteComplexCondition(id) { return api.delete(`/siem/complex-conditions/${id}`); },

  // Hacker Groups Endpunkte
  getAllHackerGroups() { return api.get("/hackwatch/groups"); },
  getHackerGroupById(id) {return api.get(`/hackwatch/groups/${id}`);},
  createHackerGroup(data) {return api.post("/hackwatch/groups", data);},
  updateHackerGroup(id, data) {return api.put(`/hackwatch/groups/${id}`, data);},
  deleteHackerGroup(id) {return api.delete(`/hackwatch/groups/${id}`);},
  getHackerGroupsOverview(params) { return api.get("/hackwatch/groups/overview", { params }); },
  getHackerGroupsSummary() { return api.get("/hackwatch/groups/summary");},
  getHackerGroupHistory(id) { return api.get(`/hackwatch/groups/${id}/history`);},
  getHackerGroupsActivity() { return api.get("/hackwatch/groups/activity"); },
  getHackerGroupProfiles(id) { return api.get(`/hackwatch/groups/${id}/profiles`);},
  createHackerGroupProfile(id, data) { return api.post(`/hackwatch/groups/${id}/profiles`, data); },
  deleteHackerGroupProfile(id, profileId) { return api.delete(`/hackwatch/groups/${id}/profiles/${profileId}`); },
  getHackerGroupLocations(id) { return api.get(`/hackwatch/groups/${id}/locations`);},
  createHackerGroupLocation(id, data) { return api.post(`/hackwatch/groups/${id}/locations`, data); },
  deleteHackerGroupLocation(id, locationId) { return api.delete(`/hackwatch/groups/${id}/locations/${locationId}`); },
  // --- Groups: extra views/endpoints ---
  getGroupSummary(id) { return api.get(`/hackwatch/groups/${id}/summary`); },
  getGroupPosts(id, params) { return api.get(`/hackwatch/groups/${id}/posts`, { params }); },
  getGroupTTPs(id, params) { return api.get(`/hackwatch/groups/${id}/ttps`, { params }); },
  getGroupAliases(id) { return api.get(`/hackwatch/groups/${id}/aliases`); },
  createGroupAlias(id, payload) { return api.post(`/hackwatch/groups/${id}/aliases`, payload); },
  deleteGroupAlias(id, aliasId) { return api.delete(`/hackwatch/groups/${id}/aliases/${aliasId}`); },

  // Übersicht (existiert bei dir bereits als /hackwatch/groups/overview)
  getGroupsOverview(params) { return api.get('/hackwatch/groups/overview', { params }); },
  getGroupsFacets() { return api.get('/hackwatch/groups/facets'); },
  getGroupsStats(params) { return api.get('/hackwatch/groups/stats', { params }); },
  getHackerGroupNames() { return api.get('/hackwatch/groups/names'); },
// Hacker Group Tools

getHackerGroupToolsLinks(groupId, params) {
  // Erwartet: GET /hackwatch/groups/:id/tools/links
  return api.get(`/hackwatch/groups/${groupId}/tools/links`, { params });
},
getTopToolsGlobal(params) {
  return api.get('/hackwatch/tools/top', { params });
},
getToolsSummary() { return api.get('/hackwatch/tools/summary'); },
getToolsStats()   { return api.get('/hackwatch/tools/stats'); },
// (Optional – falls du später Einzelabfragen brauchst)
getHackerGroupToolById(toolId) {
  return api.get(`/hackwatch/groups/${toolId}/tools`);
},

// IOCs
getIOCs(params)                    { return api.get('/hackwatch/iocs', { params }); },
getIOCsStats()                     { return api.get('/hackwatch/iocs/stats'); },
getGroupIOCs(groupId, params)      { return api.get(`/hackwatch/groups/${groupId}/iocs`, { params }); },
createGroupIOC(groupId, payload)   { return api.post(`/hackwatch/groups/${groupId}/iocs`, payload); },
updateIOC(iocId, payload)          { return api.put(`/hackwatch/iocs/${iocId}`, payload); },
deleteIOC(iocId)                   { return api.delete(`/hackwatch/iocs/${iocId}`); },
deleteAllGroupIOCs(groupId)        { return api.delete(`/hackwatch/groups/${groupId}/iocs`); },

// Hack-Opfer / Betroffene Unternehmen (Entity Resolution)
getHackVictims(params)             { return api.get('/hackwatch/victims', { params }); },
getHackVictimsStats()             { return api.get('/hackwatch/victims/stats'); },
getHackVictimsFilterOptions()     { return api.get('/hackwatch/victims/filter-options'); },
getHackVictim(id)                  { return api.get(`/hackwatch/victims/${id}`); },
updateHackVictim(id, payload)      { return api.put(`/hackwatch/victims/${id}`, payload); },
mergeHackVictims(id, sourceIds)    { return api.post(`/hackwatch/victims/${id}/merge`, { source_ids: sourceIds }); },
unmergeHackVictim(id)              { return api.post(`/hackwatch/victims/${id}/unmerge`); },
moveHackPost(payload)              { return api.post('/hackwatch/victims/move-post', payload); },
unlockHackPost(postId)             { return api.post(`/hackwatch/posts/${postId}/unlock`); },
resolveHackVictims()              { return api.post('/hackwatch/victims/resolve'); },

// TTPs (MITRE ATT&CK)
getTTPs(params) { return api.get('/hackwatch/ttps', { params }); },
getTTP(id) {return api.get(`/hackwatch/ttps/${id}`);},
getTTPWorkflows(id) { return api.get(`/hackwatch/ttps/${id}/workflows`); },
getTTPGroups(id, params) { return api.get(`/hackwatch/ttps/${id}/groups`, { params }); },
getGroupWorkflowCoverage(groupId, params) { return api.get(`/hackwatch/groups/${groupId}/workflows`, { params }); },
createTTP(payload) { return api.post('/hackwatch/ttps', payload); },
updateTTP(id, payload) { return api.put(`/hackwatch/ttps/${id}`, payload); },
deleteTTP(id) { return api.delete(`/hackwatch/ttps/${id}`); },



  // Hacker Posts Endpunkte
  getAllHackPosts() { return api.get("/hackwatch/posts"); },

  getHackwatchPost(postId) {
    return api.get(`/hackwatch/posts/${postId}`)
  },
  getHackwatchPosts(params) {
    return api.get('/hackwatch/posts', { params })
  },

  getHackPostById(id) { return api.get(`/hackwatch/posts/${id}`); },
  createHackPost(data) { return api.post("/hackwatch/posts", data); },
  updateHackPost(id, data) { return api.put(`/hackwatch/posts/${id}`, data); },
  deleteHackPost(id) { return api.delete(`/hackwatch/posts/${id}`); },
  getPostsStats(params) { return api.get('/hackwatch/posts/stats', { params }); },
  getHackPostsSummary() { return api.get("/hackwatch/posts/summary"); },
  getHackPostsFiltered(query) { return api.get("/hackwatch/posts", { params: query }); },
  getHackedCompaniesByGroup(query) {  return api.get("/hackwatch/posts/hacked-companies", { params: query }); },
  getHackPostsCountrySummary(query) { return api.get("/hackwatch/posts/country-summary", { params: query }); },
  getAttackArcs(params) { return api.get('/hackwatch/posts/attack-arcs', { params }); },
  getHackPostsFilterOptions()       { return api.get("/hackwatch/posts/filter-options"); },
  getHackPostDetailSettings()       { return api.get("/hackwatch/posts/detail-settings"); },
  createHackPostDetail(postId, data)              { return api.post(`/hackwatch/posts/${postId}/details`, data); },
  updateHackPostDetail(postId, detailId, data)    { return api.put(`/hackwatch/posts/${postId}/details/${detailId}`, data); },
  deleteHackPostDetail(postId, detailId)          { return api.delete(`/hackwatch/posts/${postId}/details/${detailId}`); },
  releaseHackPostDetail(postId, detailId)         { return api.patch(`/hackwatch/posts/${postId}/details/${detailId}/release`); },
  getRansomwareExtensionsMapping(query) { return api.get("/hackwatch/extensions", { params: query }); },
  createRansomwareExtensionMapping(payload) {
    // POST /hackwatch/extensions
    // payload: { extension_name, hacker_group_id }
    return api.post('/hackwatch/extensions', payload)
  },
  updateRansomwareExtensionMapping(id, payload) {
    // PUT /hackwatch/extensions/:id
    return api.put(`/hackwatch/extensions/${id}`, payload)
  },
  deleteRansomwareExtensionMapping(id) {
    // DELETE /hackwatch/extensions/:id
    return api.delete(`/hackwatch/extensions/${id}`)
  },
   // Alle RSS Feeds abrufen
   getRssFeeds() {
    return api.get("/rss/feeds");
  },
  getRssFeedsSummary() { return api.get("/rss/feeds/summary"); },

  // Einen einzelnen RSS Feed anhand seiner ID abrufen
  getRssFeedById(id) {
    return api.get(`/rss/feeds/${id}`);
  },

  // Einen neuen RSS Feed erstellen
  createRssFeed(data) {
    return api.post("/rss/feeds", data);
  },

  // Einen bestehenden RSS Feed aktualisieren
  updateRssFeed(id, data) {
    return api.put(`/rss/feeds/${id}`, data);
  },

  // Einen RSS Feed löschen
  deleteRssFeed(id) {
    return api.delete(`/rss/feeds/${id}`);
  },

  // Optional: RSS Feed Items abrufen
  getRssFeedItems(params) { return api.get("/rss/feed-items", { params }); },
  getRssFeedItemFilterOptions() { return api.get("/rss/feed-items/filter-options"); },
  getNewsStats(params) { return api.get('/rss/feed-items/stats', { params }); },

  // Optional: Ein einzelnes RSS Feed Item abrufen
  getRssFeedItemById(id) {
    return api.get(`/rss/feed-items/${id}`);
  },

  // Ein RSS Feed Item bearbeiten (manuelle Korrektur von Metadaten/Geo)
  updateRssFeedItem(id, data) {
    return api.put(`/rss/feed-items/${id}`, data);
  },

  // Optional: Ein RSS Feed Item löschen
  deleteRssFeedItem(id) {
    return api.delete(`/rss/feed-items/${id}`);
  },

  // Audit Logs
  getAuditLogs(params) {
    return api.get('/audit-logs', { params });
  },

  // Partner Customers
  getPartnerCustomersSummary()      { return api.get('/partner-customers/summary') },
  getPartnerCustomersSyncOverview() { return api.get('/partner-customers/sync-overview') },
  // Cross-Customer-Alarme (Dashboard-Widget + Notification-Poller)
  getPartnerCustomerEvents(params)  { return api.get('/partner-customers/events', { params }) },

  // Multi-dashboard
  getDashboards()              { return api.get('/users/me/dashboards') },
  createDashboard(data)        { return api.post('/users/me/dashboards', data) },
  getDashboard(id)             { return api.get(`/users/me/dashboards/${id}`) },
  updateDashboard(id, data)    { return api.put(`/users/me/dashboards/${id}`, data) },
  deleteDashboard(id)          { return api.delete(`/users/me/dashboards/${id}`) },

  getActivity(params = {})     { return api.get('/system/activity', { params }) },
  getSystemStatus()            { return api.get('/system/status') },

  // Personal API Keys
  getMyApiKeys()               { return api.get('/users/me/api-keys') },
  getMyApiKeyScopes()          { return api.get('/users/me/api-keys/available-scopes') },
  createMyApiKey(data)         { return api.post('/users/me/api-keys', data) },
  revokeMyApiKey(id)           { return api.delete(`/users/me/api-keys/${id}`) },

  // MFA / 2FA (TOTP)
  getMfaStatus()                   { return api.get('/auth/mfa/status') },
  setupMfa()                       { return api.post('/auth/mfa/setup') },
  enableMfa(code)                  { return api.post('/auth/mfa/enable', { code }) },
  disableMfa(password)             { return api.post('/auth/mfa/disable', { password }) },
  regenerateMfaBackupCodes(password) { return api.post('/auth/mfa/backup-codes/regenerate', { password }) },
  revokeMfaTrustedDevice(id)       { return api.delete(`/auth/mfa/trusted-devices/${id}`) },
  revokeAllMfaTrustedDevices()     { return api.delete('/auth/mfa/trusted-devices') },

  // Notifications — In-App-Postfach + Alarm-Präferenzen
  getNotifications(params = {})       { return api.get('/notifications', { params }) },
  getNotificationsUnread()            { return api.get('/notifications/unread-count') },
  markNotificationRead(id)            { return api.patch(`/notifications/${id}/read`) },
  markAllNotificationsRead()          { return api.post('/notifications/read-all') },
  getNotificationTypes()              { return api.get('/notifications/types') },
  getNotificationPreferences()        { return api.get('/notifications/preferences') },
  updateNotificationPreferences(data) { return api.put('/notifications/preferences', data) },
};
